export default new Date().getDay() - 1;
